<div class="docviewer-bottom">
    <ngx-extended-pdf-viewer #pdfViewer [src]="src" [height]="height" [useBrowserLocale]="true"
        [showDownloadButton]="config?.showDownloadButton" [showPrintButton]="showPrintButton"
        [showOpenFileButton]="config?.showOpenFileButton" [showSidebarButton]="config?.showSidebarButton"
        [showBookmarkButton]="config?.showBookmarkButton"
        [showSecondaryToolbarButton]="config?.showSecondaryToolbarButton"
        [showPresentationModeButton]="config?.showPresentationModeButton" 
        (pagesLoaded)="onPagesLoad($event)" >
    </ngx-extended-pdf-viewer>
</div>